import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import HomeIcon from "@mui/icons-material/Home";
import { TextField, Typography, Stack, Paper } from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import { Dialog, DialogTitle, DialogContent, DialogActions, Box } from "@mui/material";
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material"; // ajoute en haut si pas déjà là
import { IconButton, InputAdornment } from "@mui/material";

import EmojiPicker from "../components/EmojiPicker.js";
import BoutonPaiement from "../components/BoutonPaiement.js"
import { allEmojis } from "../components/EmojiPicker.js";
import PhoneInput from "../components/common/PhoneInput.js";

import { logDev } from "../utils/logger.js";
import { buildPaiementUrl } from "../utils/navigation.js";
import { nettoyerPhone, isValidPhone, buildFullNumber } from "../utils/phoneUtils.js";

import { useGroupe } from "../context/GroupeContext.js";
import { useLanguage } from '../context/LanguageContext.js';

import SnackbarFeedback from "../pages/SnackbarFeedback.js";

const FormulaireGroupe = ({ onGroupeCree, setMode = () => {} }) => {
  
  const [nomGroupe, setNomGroupe] = useState("");
  const [emailCreateur, setEmailCreateur] = useState("");
  const [motdepasseAdmin, setMotdepasseAdmin] = useState("");
  const [motdepasseUtilisateur, setMotdepasseUtilisateur] = useState("");
  const [couleur, setCouleur] = useState("#71685e"); // couleur par défaut
  const [emoji, setEmoji] = useState("");
  const [erreurEmail, setErreurEmail] = useState("");
  const [erreurTel, setErreurTel] = useState("");
  const [cguAccepted, setCguAccepted] = useState(false);

  const [headerHeight, setHeaderHeight] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);
  const [mainMenuHeight, setMainMenuHeight] = useState(0);
 
  const [erreurNom, setErreurNom] = useState("");
  const [erreurGlobal, setErreurGlobal] = useState("");
  
  const [showWarning, setShowWarning] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();
  const [showAdminPassword, setShowAdminPassword] = useState(false);
  const [showUserPassword, setShowUserPassword] = useState(false);
  const { setGroupe } = useGroupe();
  const [groupeId, setGroupeId] = useState(null);
  const { t } = useLanguage();

  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [bottomNavHeight, setBottomNavHeight] = useState(0);

  const [indicatif, setIndicatif] = useState("+33");
  const [numeroSansIndicatif, setNumeroSansIndicatif] = useState("");

  useEffect(() => {
  const header = document.querySelector('.header');
  const footer = document.querySelector('.footer');
  const menu = document.querySelector('.main-menu');

  const updateHeights = () => {
    if (header) setHeaderHeight(header.offsetHeight);
    if (footer) setFooterHeight(footer.offsetHeight);
    if (menu) setMainMenuHeight(menu.offsetHeight);
  };

  updateHeights();
  window.addEventListener('resize', updateHeights);
  return () => window.removeEventListener('resize', updateHeights);
  }, []);

  const topOffset = headerHeight + (isMobile ? footerHeight : mainMenuHeight);
  const bottomOffset = isMobile ? mainMenuHeight : 0;

  useEffect(() => {
    const nav = document.querySelector('.MuiBottomNavigation-root');
    if (nav) {
      const updateHeight = () => setBottomNavHeight(nav.offsetHeight);
      updateHeight();
      window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErreurNom("");
    setErreurEmail("");

  const telNettoye = buildFullNumber(indicatif, numeroSansIndicatif);
  const nomNettoye = (nomGroupe ?? "").trim(); 
  const emailNettoye = (emailCreateur ?? "").trim().toLowerCase();
  console.log("DEBUG EMAIL:", emailCreateur, emailNettoye);


  try {
    logDev("[FormulaireGroupe] tentative création", { nomNettoye, emailNettoye, telNettoye });

    // 🔍 Vérifie si le groupe existe déjà
    const checkRes = await axios.get(
      `${process.env.REACT_APP_API}/groupes/check?nom=${encodeURIComponent(nomNettoye)}`
    );
    logDev("[FormulaireGroupe] check groupe existant", checkRes.data); 

    if (checkRes.data.exists) {
      setErreurNom(t('ExistingGroup'));
      setSnackbar({
        open: true,
        message: t("ExistingGroup"),
        severity: "error"
      });

      return;
    }

    // ✅ Nettoyage des mots de passe
    const motdepasseAdminNettoye = (motdepasseAdmin ?? "").trim();
    const motdepasseUtilisateurNettoye = (motdepasseUtilisateur ?? "").trim();

    logDev("[FormulaireGroupe] mots de passe nettoyés", {
      admin: motdepasseAdminNettoye,
      user: motdepasseUtilisateurNettoye,
    });

    if (motdepasseAdminNettoye === motdepasseUtilisateurNettoye) {
      setShowWarning(true);
      setSnackbar({
      open: true,
      message: t("PasswordsMustDiffer"),
      severity: "warning"
    });

      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailNettoye)) {
      setErreurEmail(t("InvalidEmailFormat"));
      setSnackbar({
        open: true,
        message: t("InvalidEmailFormat"),
        severity: "error"
      });
    return;
    }

  if (!isValidPhone(telNettoye)) {
    setErreurTel(t("InvalidPhoneFormat"));
    setSnackbar({
      open: true,
    message: t("InvalidPhoneFormat"),
      severity: "error"
  });
  return;
  }

  logDev("[FormulaireGroupe] données envoyées", {
    nom: nomNettoye,
    motdepasseAdmin: motdepasseAdminNettoye,
    motdepasseUtilisateur: motdepasseUtilisateurNettoye,
    createur: emailNettoye,
    telephone: telNettoye,
    emoji,
    couleur
  });

    // 📦 Envoi au backend
    const res = await axios.post(`${process.env.REACT_APP_API}/groupes`, {
      nom: nomNettoye,
      motdepasseAdmin: motdepasseAdminNettoye,
      motdepasseUtilisateur: motdepasseUtilisateurNettoye,
      createur: emailNettoye,
      telephone: telNettoye,
      emoji,
      couleur
    });

    setGroupeId(res.data._id);

    logDev("[FormulaireGroupe] groupe créé", res.data);

    // ✅ Mets à jour le contexte directement
    setGroupe(res.data._id, res.data.role);

    // ✅ Stockage minimal côté client
    if (res.data.utilisateurId) {
      sessionStorage.setItem("utilisateurId", res.data.utilisateurId);
    }
    sessionStorage.setItem("groupeId", res.data._id);
    sessionStorage.setItem("role", res.data.role); // "admin"
    sessionStorage.setItem("emailConnect", res.data.createur);
    localStorage.setItem("groupeId", res.data._id);
    localStorage.setItem("role", res.data.role);

    logDev("[FormulaireGroupe] stockage local/session", {
      groupeId: res.data._id,
      role: res.data.role,
      emailConnect: res.data.createur,
    });

    // Transmission au parent
    if (onGroupeCree) {
      onGroupeCree(res.data);
    }

    setSnackbar({
      open: true,
      message: t("GroupCreatedSuccessfully"),
      severity: "success"
    });

    // Redirection
    setTimeout(() => {
      navigate("/contacts");
    }, 1000); // ⏱️ laisse le temps au snackbar de s’affiche
  } 

  catch (err) {
    logDev("❌ Erreur création groupe", {
      message: err.message,
      response: err.response?.data,
      stack: err.stack
  });

  console.log("ERR BACK:", err.response?.data);

  const status = err.response?.status;
  const message = err.response?.data?.message || "";

  if (status === 409) {
    const motif = err.response?.data?.motifBlocage;

    switch (motif) { 
      case "nom_deja_utilise": 
        setErreurNom(t("NameAlreadyUsed")); 
        setSnackbar({ 
          open: true, 
          message: t("NameAlreadyUsed"), severity: "error" }); 
        return; 

      case "telephone_deja_utilise": 
        setErreurTel(t("PhoneAlreadyUsed")); 
        setSnackbar({ 
          open: true, 
          message: t("PhoneAlreadyUsed"), 
          severity: "error" 
        }); 
        return; 

      case "email_deja_utilise": 
        setErreurEmail(t("EmailAlreadyTaken")); 
        setSnackbar({ 
          open: true, 
          message: t("EmailAlreadyTaken"), 
          severity: "error" 
        }); 
        return;

        default: 
          setSnackbar({ 
            open: true, 
            message: err.response.data.message || t("UnableToCreateGroup"), 
            severity: "error" 
          }); 
          return; 
        }
    }

  if (status === 403) {
    const motif = err.response?.data?.motifBlocage;
    const groupeId = err.response?.data?.groupeId;
    const utilisateurId = err.response?.data?.utilisateurId;

    if (utilisateurId) {
    sessionStorage.setItem("utilisateurId", utilisateurId);
    logDev("💾 utilisateurId stocké depuis erreur quota", utilisateurId);
  }

    const telBack = err.response?.data?.tel;
    const emailBack = err.response?.data?.email;
    const groupeIdBack = err.response?.data?.groupeId;

    switch (motif) {
      case "PackageRequired":
        setSnackbar({
          open: true,
          message: t("PackageRequired"),
          severity: "warning"
        });
        
        if (groupeId && groupeId !== "null") {
        navigate(`/paiement/${groupeId}`);
      } else {
        // 🔹 fallback si pas de groupeId
        navigate(`/paiement?email=${encodeURIComponent(emailNettoye)}&tel=${encodeURIComponent(telNettoye)}`);
      }
      return;

    // 🔔 L'encart et le bouton sont gérés par bouton paiement
    case "quota_atteint":
      setErreurNom("quota");
      setSnackbar({
        open: true,
        message: t("QuotaReached"), // "Vous avez atteint le nombre maximum de groupes autorisés."
        severity: "error"
      });

      // 🔹 stocke les infos pour BoutonPaiement
      if (groupeId && groupeId !== "null" && groupeId !== "undefined") {
        sessionStorage.setItem("groupeId", groupeId);
      } else {
        if (telBack) sessionStorage.setItem("paiementTel", telBack);
        if (emailBack) sessionStorage.setItem("emailConnect", emailBack);;
      }
      return;

    case "premierEssaiGratuit_utilise":
      setErreurNom("quota"); // ou un alias que BoutonPaiement comprend
      setSnackbar({
        open: true,
        message: t("FreeTrialGroupAlreadyUsed"),
        severity: "error"
      });

      if (groupeIdBack) {
        sessionStorage.setItem("groupeId", groupeIdBack);
      } else {
      if (telBack) sessionStorage.setItem("paiementTel", telBack);
      if (emailBack) sessionStorage.setItem("emailConnect", emailBack);
      }
      return;
       
    case "groupe_supprime":
      setErreurNom(t("GroupAlreadyUsedRGPD"));
      // stocke les infos pour BoutonPaiement
      if (groupeId) {
      sessionStorage.setItem("groupeId", groupeId);
    } else {
      sessionStorage.setItem("paiementTel", telNettoye);
      sessionStorage.setItem("emailConnect", emailNettoye);
    }
    return;

    case "rgpd_reutilisation":
      const { hashCreateur, tel, email } = err.response.data;
      const messageRGPD = t("GroupAlreadyUsedRGPD");

      setErreurNom(t("GroupAlreadyUsedRGPD"));
      setSnackbar({
        open: true,
        message: messageRGPD,
        severity: "warning"
      });

    // stocke les infos pour BoutonPaiement
    if (groupeId && groupeId !== "null" && groupeId !== "undefined") {
      sessionStorage.setItem("groupeId", groupeId);
    } else {
      sessionStorage.setItem("paiementTel", tel);
      sessionStorage.setItem("emailConnect", email);
    }
    sessionStorage.setItem("hashCreateur", hashCreateur);
    return;

    case "telephone_deja_utilise":
    setErreurNom(t("PhoneAlreadyUse")); // "Ce numéro de téléphone est déjà utilisé."
    setSnackbar({
      open: true,
      message: t("PhoneAlreadyUse"),
      severity: "error"
    });

    if (groupeId) {
      sessionStorage.setItem("groupeId", groupeId);
    } else {
      sessionStorage.setItem("paiementTel", telNettoye);
      sessionStorage.setItem("emailConnect", emailNettoye);
    }
    return;

    case "email_deja_utilise":
    setErreurNom(t("EmailAlreadyTaken")); // "Cette adresse email est déjà utilisée."
    setSnackbar({
      open: true,
      message: t("EmailAlreadyTaken"),
      severity: "error"
    });

    if (groupeId) {
      sessionStorage.setItem("groupeId", groupeId);
    } else {
      sessionStorage.setItem("paiementTel", telNettoye);
      sessionStorage.setItem("emailConnect", emailNettoye);
    }
    return;

    case "nom_deja_utilise":
    setErreurNom(t("NameAlreadyUsed")); // "Nom de groupe déjà pris"
    setSnackbar({
      open: true,
      message: t("NameAlreadyUsed"),
      severity: "error"
    });
    return;

    case "email_ou_tel_deja_utilise":
    setErreurNom(t("DuplicateUserError")); // "Email ou téléphone déjà utilisé"
    setSnackbar({
      open: true,
      message: t("DuplicateUserError"),
      severity: "error"
    });

    if (groupeId) {
      sessionStorage.setItem("groupeId", groupeId);
    } else {
      if (telBack) sessionStorage.setItem("paiementTel", telBack);
      if (emailBack) sessionStorage.setItem("emailConnect", emailBack);
    }
    return;

    case "quota_non_defini":
    setErreurNom("quota"); 
    setSnackbar({
      open: true,
      message: t("QuotaNotDefined"), // "Quota non défini pour cet utilisateur."
      severity: "error"
    });

    // 🔹 stocke les infos minimales pour BoutonPaiement
    if (telBack) sessionStorage.setItem("paiementTel", telBack);
    if (emailBack) sessionStorage.setItem("emailConnect", emailBack);
    return;

    logDev("🔁 Blocage traité", { motif, groupeId });
    return;

    default:
      logDev("❓ Motif de blocage inconnu", { motif, message });

      if (message.toLowerCase().includes("quota")) {
        setErreurNom(t("GroupeOneQuotaReached"));     

        if (groupeId) {
          setGroupeId(groupeId);
          sessionStorage.setItem("groupeId", groupeId);
        } else {
          sessionStorage.setItem("paiementTel", telNettoye);
          sessionStorage.setItem("emailConnect", emailNettoye);
        }
        return;
      }

      if (message.toLowerCase().includes("supprimé")) {
        setErreurNom(t("GroupDeletedOrFrozen"));
        // stocke les infos pour BoutonPaiement
        if (groupeId) {
      sessionStorage.setItem("groupeId", groupeId);
    } else {
      sessionStorage.setItem("paiementTel", telNettoye);
      sessionStorage.setItem("emailConnect", emailNettoye);
    }
    return;
  }
}
}
  setErreurNom((t('UnableToCreateGroup')));
}

}
  return (
     <>
      <Box
        sx={{
          minHeight: "auto", // prend toute la hauteur de l'écran
          display: "block",
          justifyContent: "center",
          alignItems: "flex-start",
          paddingX: 2, // marge horizontale sur mobile
          paddingTop: `${topOffset}px`,
          paddingBottom: `${bottomOffset}px`,
          boxSizing: "border-box",
          backgroundColor: "#f4ece2"
        }}
      >
      {/* 👇 ouverture du form */}
      <form onSubmit={handleSubmit}>
      <Stack spacing={2} sx={{ maxWidth: 360, width: "100%", marginBottom: 8, marginTop: isMobile ? 0 : 8}}>
    
      {/* 🔔 Notice rôle : message différent pour admin ou utilisateur */}
      <div
        style={{
          backgroundColor: "#2f2f2fff",
          padding: "12px 16px",
          borderRadius: "6px",
          marginBottom: "12px",
          fontSize: "1rem",
          fontWeight: "bold",
          textAlign: "center",
          color: "#fff",
          border: "2px solid #d4af37", // doré
          boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
          backgroundImage: "radial-gradient(circle at top left, rgba(255,255,255,0.05), transparent 70%)"
        }}
        >   
        {t('AdminRole')}
        </div>
        <div
          style={{
            backgroundColor: "#2f2f2fff",
            padding: "12px 16px",
            borderRadius: "6px",
            marginBottom: "12px",
            fontSize: "1rem",
            fontWeight: "bold",
            textAlign: "center",
            color: "#fff",
            border: "2px solid #d4af37", // doré
            boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
            backgroundImage: "radial-gradient(circle at top left, rgba(255,255,255,0.05), transparent 70%)"
          }}
        >   
        {t('UsersRole')}
        </div>          

        <TextField
          label={t('GroupName')}
          variant="outlined"
          fullWidth
          value={nomGroupe}
          onChange={(e) => setNomGroupe(e.target.value)}
          error={false}
          sx={{
            backgroundColor: "#fff",   // 👈 fond blanc
            borderRadius: 1            // 👈 arrondi léger (optionnel)
          }}
        />


        {/* 🔹 GERE l'AFFICHAGE ENCART + LIEN PAIEMENT */}
        <BoutonPaiement
          groupeId={groupeId}
          nomGroupe={nomGroupe}
          erreurNom={erreurNom}
        />

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <FormControl sx={{ minWidth: 80 }}>
          <InputLabel>{t("EmojiTheme")}</InputLabel>
          <Select
            value={emoji}
            onChange={(e) => setEmoji(e.target.value)}
            label={t("EmojiTheme")}
            size="small"
          >
         {allEmojis.map((em) => (
          <MenuItem key={em} value={em}>
          <Typography sx={{ fontSize: "1.5rem" }}>{em}</Typography>
          </MenuItem>
          ))}
          </Select>
          </FormControl>

        <input
          type="color"
          value={couleur}
          onChange={(e) => setCouleur(e.target.value)}
          style={{
            width: "36px",
            height: "36px",
            border: "none",
            cursor: "pointer",
            borderRadius: "4px"
          }}
        />
        </Box>

        <TextField
        label={t('CreatorMail')}
        /*type="email"*/
        type="text"
        variant="outlined"
        fullWidth
        value={emailCreateur}
        onChange={(e) => setEmailCreateur(e.target.value)}
        error={!!erreurEmail}
        helperText={erreurEmail} // ✅ Affiche le message
        sx={{
          backgroundColor: "#fff",   // 👈 fond blanc
          borderRadius: 1            // 👈 arrondi léger (optionnel)
        }}
        />

        <PhoneInput
        indicatif={indicatif}
        setIndicatif={setIndicatif}
        numero={numeroSansIndicatif}
        setNumero={setNumeroSansIndicatif}
        erreurTel={erreurTel}
        t={t}
      />

        <TextField
        label={t('AdminPassword')}
        type={showAdminPassword ? "text" : "password"}
        variant="outlined"
        fullWidth
        value={motdepasseAdmin}
        onChange={(e) => setMotdepasseAdmin(e.target.value)}
        sx={{
          backgroundColor: "#fff",   // 👈 fond blanc
          borderRadius: 1            // 👈 arrondi léger (optionnel)
        }}
        InputProps={{
          endAdornment: (
          <InputAdornment position="end">
          <IconButton
            onClick={() => setShowAdminPassword(prev => !prev)}
            onMouseDown={(e) => e.preventDefault()}
            edge="end"
          >
          {showAdminPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
          </InputAdornment>
          )
        }}
        />

        <TextField
          label={t('UserPassword')}
          type={showUserPassword ? "text" : "password"}
          variant="outlined"
          fullWidth
          value={motdepasseUtilisateur}
          onChange={(e) => setMotdepasseUtilisateur(e.target.value)}
          sx={{
            backgroundColor: "#fff",   // 👈 fond blanc
            borderRadius: 1            // 👈 arrondi léger (optionnel)
          }}
          InputProps={{
            endAdornment: (
            <InputAdornment position="end">
            <IconButton
              onClick={() => setShowUserPassword(prev => !prev)}
              onMouseDown={(e) => e.preventDefault()}
              edge="end"
            >
            {showUserPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
            </InputAdornment>
            )
          }}
        />

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
  
      <input
        type="checkbox"
        checked={cguAccepted}
        onChange={(e) => setCguAccepted(e.target.checked)}
        id="cgu-checkbox"
      />
  
      <label htmlFor="cgu-checkbox" style={{ fontSize: isMobile ? "0.45rem" : "0.65rem" }}>
      {t("AcceptCGUAndRGPD")}{" "}
      <a href="/cgu" target="_blank" rel="noopener noreferrer">
      {t("ReadRules")}
    </a>
  </label>
</Box>

      <Button
        type="submit"
        variant="contained"
        startIcon={<AddIcon />}
        disabled={!cguAccepted}
        sx=
          {{ 
            color: "#fff",    
            backgroundColor: "#8C78EB",          // texte
            borderColor: "#8C78EB",        // bordure
              '&:hover': {
            backgroundColor: "#8C78EB",  // fond au survol
            color: "#fff",               // texte au survol
            }, 
            fontWeight: "bold", 
            fontSize: "1rem",
            mt: 2
            }} 
            >
             {t('GroupCreate')}
            </Button>
          </Stack>
        </form>

          <Dialog open={showWarning} onClose={() => setShowWarning(false)}>
            <DialogTitle>{t('Warning')}</DialogTitle>
              <DialogContent>
              <Typography>
              {t('SamePasswordWarning')}
              </Typography>
              </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowWarning(false)} autoFocus>
            OK
            </Button>
          </DialogActions>
          </Dialog>

          <Paper
            elevation={6} // ⬅️ Ombre MUI intégrée
            sx={{
              position: "fixed",
              left: 0,
              right: 0,
              zIndex: 10,
              bottom: isMobile ? 0 : "auto",
              top: isMobile ? "auto" : `${headerHeight}px`,
            }}
          >
       
        <BottomNavigation
          showLabels
          value="creation"
          onChange={(event, newValue) => {
            if (newValue === "home") navigate("/");
            else if (newValue === "connexion") navigate("/connexion");
            else if (newValue === "creation") navigate("/creation");
          }}
          sx={{
            position: "fixed",
            left: 0,
            right: 0,
            zIndex: 10,
            bottom: isMobile ? 0 : "auto",  // ✅ bas si mobile
            top: isMobile ? "auto" : `${headerHeight}px` ,
            borderTop: "1px solid #ccc",
            backgroundColor: "#e4dcd2", // ✅ couleur personnalisée
            color: "white",             // ✅ couleur du texte (si nécessaire)
              "&.Mui-selected": {
            color: "#3399FF", // ✅ couleur quand sélectionné
            },
            
          }}
        >
          <BottomNavigationAction
            label={t('Home')}
            value={"home"} // 👈 revient à l’état initial
            icon={<HomeIcon />}
            />

          <BottomNavigationAction
            label={t('ConnectToAGroup')}
            value="connexion"
            icon={<LoginIcon />}
          />
          <BottomNavigationAction
            label={t('CreateNewGroup')}
            value="creation"
            icon={<GroupAddIcon />}
          />
        </BottomNavigation>
        </Paper>
         </Box>
         <SnackbarFeedback
            snackbar={snackbar}
            setSnackbar={setSnackbar}
            bottomNavHeight={bottomNavHeight}
        />

      </>
  );
  };

export default FormulaireGroupe;